import { useCallback } from 'react';

import { useLanguageContext } from '../context/language-context';
import translate from '../util/translate';

/**
 * Translation hook bound to the current application language.
 *
 * Usage:
 *   const { t, currentLanguage } = useTranslation();
 *   <Button>{t('common.save')}</Button>
 *
 * @returns {{ t: (key: string) => string, currentLanguage: string }}
 */
const useTranslation = () => {
    const { currentLanguage } = useLanguageContext();

    const t = useCallback(
        (key) => translate(key, currentLanguage),
        [currentLanguage]
    );

    return { t, currentLanguage };
};

export default useTranslation;
